// extracted by mini-css-extract-plugin
export default {"privacy-policy":"privacy-policy_privacy-policy__5820v","heading":"privacy-policy_heading__du-68"};